import {
  getActiveStorageUserId,
  requireActiveStorageUserId,
  resolveStorageUserId,
  userLocalStorageKey,
} from './user-storage-scope'

export type LiteraStorageKeys = {
  projectId: string
  messages: (projectId: string) => string
  phase: (projectId: string) => string
  outline: (projectId: string) => string
  analysis: (projectId: string) => string
  artifact: (projectId: string) => string
  generatorState: string
  messagesPrefix: string
}

export function literaStorageKeys(userId?: string | null): LiteraStorageKeys {
  const uid = resolveStorageUserId(userId)
  const prefix = userLocalStorageKey(uid, '')
  const base = prefix.endsWith('-') ? prefix.slice(0, -1) : prefix
  return {
    projectId: `${base}-litera-project-id`,
    messages: (projectId: string) => `${base}-messages-${projectId}`,
    phase: (projectId: string) => `${base}-phase-${projectId}`,
    outline: (projectId: string) => `${base}-outline-${projectId}`,
    analysis: (projectId: string) => `${base}-analysis-${projectId}`,
    artifact: (projectId: string) => `${base}-litera-artifact-saved-v4-${projectId}`,
    generatorState: `${base}-litera-generator-state`,
    messagesPrefix: `${base}-messages-`,
  }
}

export function activeLiteraStorageKeys(): LiteraStorageKeys {
  return literaStorageKeys(requireActiveStorageUserId())
}

export function tryActiveLiteraStorageKeys(): LiteraStorageKeys | null {
  const uid = getActiveStorageUserId()
  return uid ? literaStorageKeys(uid) : null
}

export function resolveLiteraStorageKeys(): LiteraStorageKeys {
  const active = tryActiveLiteraStorageKeys()
  if (active) return active
  return {
    projectId: LEGACY_LITERA_KEYS.projectId,
    messages: (projectId: string) => `${LEGACY_LITERA_KEYS.messagesPrefix}${projectId}`,
    phase: (projectId: string) => `${LEGACY_LITERA_KEYS.phasePrefix}${projectId}`,
    outline: (projectId: string) => `${LEGACY_LITERA_KEYS.outlinePrefix}${projectId}`,
    analysis: (projectId: string) => `${LEGACY_LITERA_KEYS.analysisPrefix}${projectId}`,
    artifact: (projectId: string) => `${LEGACY_LITERA_KEYS.artifactPrefix}${projectId}`,
    generatorState: LEGACY_LITERA_KEYS.generatorState,
    messagesPrefix: LEGACY_LITERA_KEYS.messagesPrefix,
  }
}

/** Legacy unscoped keys used before per-user isolation. */
export const LEGACY_LITERA_KEYS = {
  projectId: 'bbg-litera-project-id',
  messagesPrefix: 'bbg-messages-',
  phasePrefix: 'bbg-phase-',
  outlinePrefix: 'bbg-outline-',
  analysisPrefix: 'bbg-analysis-',
  artifactPrefix: 'bbg-litera-artifact-saved-v4-',
  generatorState: 'bbg-litera-generator-state',
  biblePrefix: 'bbg-bible-',
} as const
